import React, { createContext, useContext } from 'react'
import { useLocalObservable } from 'mobx-react-lite'
import resourceProfileStore from './resource-profile.store'

const ResourceProfileStoreContext = createContext()

export const ResourceProfileStoreProvider = ({ children }) => {
  const store = useLocalObservable(resourceProfileStore)
  return <ResourceProfileStoreContext.Provider value={store}>{children}</ResourceProfileStoreContext.Provider>
}

export const useResourceProfileStore = () => useContext(ResourceProfileStoreContext)
